import { Predicative } from '../../types'

const похуй: Predicative = {
  type: 'predicative',
  predicative: 'похуй',
}

export default похуй
